import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-client-wise-call-dashboard',
  templateUrl: './client-wise-call-dashboard.component.html',
  styleUrls: ['./client-wise-call-dashboard.component.scss']
})
export class ClientWiseCallDashboardComponent implements OnInit {

  @ViewChild('table_3_1',{static:false}) table_3_1: ElementRef;

  authToken = localStorage.getItem('token')

  clients: any
  myColumns_3_1: any[] = ['project', 'type', 'totalLeads', 'clientDelivered', 'fresh', 'cold'];
  isShowMyTableArr_3_1: boolean = false;
  myTableArr_3_1: any;

  filterForm: FormGroup;
  isFilter: boolean = false;
  btnStatus: boolean = false;

  leadCreationDateRangeVal:any;
  projectCreationDateRangeVal:any;

  myDateRangePickerOptions = {
    dateFormat: 'dd-mm-yyyy'
  };

  constructor(
    private _fb: FormBuilder,
    private serverService: ServerService,
    private clipBoardService: ClipBoardService
  ) {
  }

  ngOnInit() {
    this.setFilter()
    this.getClients()

    this.filterForm.get('leadCreationDateRange').valueChanges.subscribe(res => {
      if (res == null) {
        this.leadCreationDateRangeVal = []
      } 
    })

    this.filterForm.get('projectCreationDateRange').valueChanges.subscribe(res => {
      if (res == null) {
        this.projectCreationDateRangeVal = []
      } 
    })


    this.filterForm.get('client').valueChanges.subscribe(res=>{
      if(res==null){
        this.isShowMyTableArr_3_1=false;
        this.myTableArr_3_1 = [];
      }
    })


  }

  setFilter() {
    this.filterForm = this._fb.group({
      client: [[], Validators.compose([Validators.required])],
      leadCreationDateRange: [],
      projectCreationDateRange: [],
    })
  }

  getClients() {
    this.serverService.clientsList(this.authToken).subscribe(data => {
      this.clients = data.client
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    })
  }


  filterSubmit() {

    this.isFilter = true;

    if (this.filterForm.invalid) {
      return false
    }

    if(this.filterForm.value.leadCreationDateRange == null){
      this.leadCreationDateRangeVal = []
    } else {
      this.leadCreationDateRangeVal = [this.filterForm.value.leadCreationDateRange.beginDate.year + '-' + this.filterForm.value.leadCreationDateRange.beginDate.month + '-' + this.filterForm.value.leadCreationDateRange.beginDate.day, this.filterForm.value.leadCreationDateRange.endDate.year + '-' + this.filterForm.value.leadCreationDateRange.endDate.month + '-' + this.filterForm.value.leadCreationDateRange.endDate.day]
    }


    if(this.filterForm.value.projectCreationDateRange == null){
      this.projectCreationDateRangeVal = []
    } else {
      this.projectCreationDateRangeVal = [this.filterForm.value.projectCreationDateRange.beginDate.year + '-' + this.filterForm.value.projectCreationDateRange.beginDate.month + '-' + this.filterForm.value.projectCreationDateRange.beginDate.day, this.filterForm.value.projectCreationDateRange.endDate.year + '-' + this.filterForm.value.projectCreationDateRange.endDate.month + '-' + this.filterForm.value.projectCreationDateRange.endDate.day]
    }


    let body = {      
      "client_ids": this.filterForm.value.client == null ? [] : [this.filterForm.value.client],
      "lead_date_range": this.leadCreationDateRangeVal,
      "date_range": this.projectCreationDateRangeVal,
    }    

    this.serverService.getClientWiseCallsReport(body, this.authToken).subscribe(data => {
      //console.log(data)
      this.isShowMyTableArr_3_1 = true;
      this.myTableArr_3_1 = data;
      //this.myTableArr_3_1 = [];
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    })

  }

  clear() {
    this.filterForm.reset()
    this.isShowMyTableArr_3_1 = false;
    this.myTableArr_3_1 = [];
  }

  generateExcelFile(data:any, name:any) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Define the file name for the Excel file
    const fileName = name;
  
    // Save the Excel file
    XLSX.writeFile(wb, fileName);
  }


  exportAsExcel_3_1() {
    const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table_3_1.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, '1-1-client-report.xlsx');
  }

}




